// src/services/dashboardService.js
import { toast } from 'react-toastify';
import { apiRequestSimple } from '../utils/apiHelper';

class DashboardService {
  static get apiBase() {
    return window.APP_CONFIG?.apiUrl || 'https://api.dpg.net.tr';
    //return process.env.REACT_APP_API_URL || 'https://localhost:44330';
  }

  // Get dashboard data
  static getDashboardData = async () => {
    const result = await apiRequestSimple('/api/dashboard/get-dashboard-data', {
      method: 'GET',
    });

    if (!result.success) {
      // If logout was triggered, don't show error toast
      if (result.requiresLogout) {
        return result;
      }
      
      console.error('Dashboard API Error:', result.error);
      return {
        success: false,
        message: result.message || 'Dashboard data could not be retrieved',
        error: result.error
      };
    }

    return {
      success: true,
      data: result.data,
      message: result.message
    };
  };
}

export default DashboardService;
